import React from "react";
import { View, Text } from "tamagui";

type EventDetailDisclaimerProps = {
  isClubRide: boolean;
};

export const EventDetailDisclaimer = ({
  isClubRide,
}: EventDetailDisclaimerProps) => {
  if (!isClubRide) return null;

  return (
    <View px="$4">
      <Text fontSize={14} fontFamily="$body">
        Disclaimer: This ride is organized by a member of the Breakfast Club
        community – it is not an official club ride. Please use caution and ride
        at your own risk.
      </Text>
    </View>
  );
};
